var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input-field',{attrs:{"label":"数据 ID","disabled":!_vm.editable},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}}),_vm._v(" "),_c('submit-field',{attrs:{"disabled":!_vm.editable || !_vm.isValid},on:{"click":_vm.submit}},[_vm._v("确定")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcdae9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/forms/dlt645-data.vue
// module id = null
// module chunks = 